<template>
    <v-flex
            class="mx-auto divHospDoc"
            max-width="344"

    >
        <v-flex text-center>
            <div class="headline text-center hospDocHeader hospDocHeaderHide">{{item.empTitlename}} <br/>{{item.empName}}</div>
            <v-list-item-avatar
                    class="docImage"
                    style="vertical-align: center"
                    tile
                    size="auto"
            >
                <v-img
                        style="width: 150px!important;"
                        class="elevation-6"
                        :src="item.empImage==''||item.empImage==undefined?defaultIcon:item.empImage"
                ></v-img>

            </v-list-item-avatar>
        </v-flex>

        <v-list-item three-line>
            <v-list-item-content>
                <div class="headline text-center hospDocHeader hospDocHeaderTitle">{{item.empTitlename}} <br/> {{item.empName}}</div>
                <div style="white-space: pre-line" v-html="item.empDoc"></div> <!--介紹-->
                <div style="white-space: pre-line" v-html="item.empExper"></div> <!--經歷-->
            </v-list-item-content>
        </v-list-item>



        <v-flex class="xs12 sm12 md12 row wrap  justify-center">
            <v-flex  v-for="(subIndex,key) in splitZone(item.zone)" :key="key" class="justify-center  lg4 md4 sm6 xs6 mx-1">
                <v-col v-if="zoneNameList.length>0" cols="12" class="regFRBtn elevation-2" @click="regDocClick(clinicTheme,item,subIndex)">
                    <span style="font-weight: bold;color: black">{{filterZone(subIndex)[0].zoneName}}</span>
                    <br/>預約掛號</v-col>
            </v-flex>
            <!--<v-flex class="text-center"><div style="color: #a39a9a">{{item.zoneName}}</div></v-flex>-->
            <!--<v-btn class="regBtn1" @click="regDocClick(item)">預約掛號</v-btn>-->
        </v-flex>

    </v-flex>
</template>

<script>
    export default {
        name: "DoctorCardA",
        props:{
            item:{
                type:Object,
            },
            clinicTheme:{
                type:String,
                default:'ClinicA'
            },
            zoneNameList:{
                type:Array,
            }
        },
        data() {
            return {
                defaultIcon:'data:image/png;base64,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',
            }
        },
        created(){
            // this.axios_getZoneNameALL();
        },
        methods:{
            regDocClick(clinicTheme,item,zone){
                // this.$router.push({name: this.clinicTheme, params:{divCode:item.divNo}, query: {empNo:item.empNo,zone:item.zone}});
                this.$router.push({name: clinicTheme, query: {empNo:item.empNo,zone:zone}}); //不分科別 依醫師代號和院區搜尋
            },
            splitZone(zone){
                let zoneList = [];
                zoneList = zone.split(',');
                return zoneList
            },
            filterZone(zone){
                return this.zoneNameList.filter((i) => {
                    return (i.zone==zone) ;
                })
            },
            axios_getZoneNameALL (){  //查詢院區名稱
                this.zoneNameList =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/ALL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneNameList = response.data.resultSet;
                    }else{
                        this.zoneNameList =[];
                    }
                }).catch(error =>  {
                    this.zoneNameList =[];
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>